module.exports = __webpack_public_path__ + "static/media/stats1965.7338ba8e.jpg";